import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { CDK_TABLE_TEMPLATE, CdkTable } from '@angular/cdk/table';

import { McRAIDataSource } from '../../models/data-source';
import { SortEvent } from '../../models/sort-event';

@Component({
  selector: 'mcrai-table',
  template: CDK_TABLE_TEMPLATE,
  styles: [`.mcrai-table{display:block}.mcrai-td,.mcrai-th{flex:1;overflow:hidden;word-break:break-word;overflow-wrap:break-word;display:flex;align-items:center;flex-flow:row wrap;min-width:0;padding:10px 15px}.mcrai-td[align-right],.mcrai-td[horizontal-right],.mcrai-th[align-right],.mcrai-th[horizontal-right]{justify-content:flex-end}.mcrai-td[align-center],.mcrai-td[horizontal-center],.mcrai-th[align-center],.mcrai-th[horizontal-center]{justify-content:center}.mcrai-td[flex-2],.mcrai-th[flex-2]{flex:2}.mcrai-td[flex-3],.mcrai-th[flex-3]{flex:3}.mcrai-td[flex-4],.mcrai-th[flex-4]{flex:4}.mcrai-td[flex-5],.mcrai-th[flex-5]{flex:5}.mcrai-td[flex-6],.mcrai-th[flex-6]{flex:6}.mcrai-td[flex-7],.mcrai-th[flex-7]{flex:7}.mcrai-td[flex-8],.mcrai-th[flex-8]{flex:8}.mcrai-td[flex-9],.mcrai-th[flex-9]{flex:9}.mcrai-td[flex-10],.mcrai-th[flex-10]{flex:10}.mcrai-tr{margin:2px 0;padding:0 2px}.mcrai-td{min-height:52px;margin:0 2px}.mcrai-th{min-height:48px;font-weight:500;margin:0 2px}`],
  encapsulation: ViewEncapsulation.None,
  preserveWhitespaces: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.mcrai-table]': 'true'
  }
})
export class TableComponent<T> extends CdkTable<T> {

  private _activeSort: SortEvent;
  get activeSort(): SortEvent {
    return this._activeSort;
  }

  @Output('sort') private _sortEvent: EventEmitter<SortEvent> = new EventEmitter<SortEvent>();

  @Input() set items(value: any[]) {
    this.dataSource = new McRAIDataSource(value);
  }

  @Input() set container(value: { items: any[] }) {
    this.dataSource = new McRAIDataSource(value.items);
  }

  public sort(id: string): void {
    switch (true) {
      case !this._activeSort:
      default:
        this._activeSort = {
          column: id,
          direction: 'desc'
        };
        break;
      case this._activeSort.column === id:
        this._activeSort = {
          column: id,
          direction: this._activeSort.direction === 'desc' ? 'asc' : 'desc'
        };
        break;
    }

    this._sortEvent.emit(this._activeSort);
  }
}
